import React from 'lib/react';
import {
  EVButton,
  EVPaper, EVTypography, makeStyles,
  EVRefreshOutlinedIcon,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import useMediaQuery from 'hooks/useMediaQuery';
import { PropTypes } from 'prop-types';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  orderHistoryRetry: {
    margin: 0,
    padding: '84px 24px',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    '@media (min-width: 640px)': {
      backgroundColor: theme.evPalette.salt[100],
      margin: '16px 24px',
      justifyContent: 'flex-start',
    },
  },
  retryBtn: {
    height: '36px',
    backgroundColor: theme.evPalette.ocean[600],
    padding: '10px',
    radius: '4px',
    gap: '8px',
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'fit-content',
    },
  },
  retryLabel: {
    columnGap: '8px',
    padding: 0,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '10px',
    textTransform: 'none',
  },
  errorMsg: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#000000',
    textAlign: 'center',
  },
}));

function RetryScreen({
  retryError, handleRetryButtonClick, className, ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(640);

  return (
    <EVPaper square={isMobile} className={clsx(classes.orderHistoryRetry, className)} {...rest}>
      <EVTypography className={classes.errorMsg}>{retryError || t('order_history__loading_error')}</EVTypography>
      <EVButton
        id="retryButton"
        variant="contained"
        color="primary"
        className={classes.retryBtn}
        classes={{ label: classes.retryLabel }}
        onClick={handleRetryButtonClick}
      >
        <EVRefreshOutlinedIcon />
        {t('order_history__retry')}
      </EVButton>
    </EVPaper>
  );
}
RetryScreen.defaultProps = {
  retryError: '',
  className: '',
};

RetryScreen.propTypes = {
  retryError: PropTypes.string,
  handleRetryButtonClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default RetryScreen;
